/**
 * TanStack Router JSON-parses each search value before validation.
 * `?priorities=1` arrives as the number 1. `?priorities=1,2` stays a string.
 * Priority filters are a comma-separated string, so a lone number has to
 * become that string. Otherwise a link to one priority opens with no filter.
 */
export function searchParamString(value: unknown): string | undefined {
  if (typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return undefined;
}
